import { ref, computed } from '@vue/composition-api'
import { getRequirementGroups } from '@/api'
import store from '@/store'

const requirementGroupsStore = ref({
  data: {},
  totalCount: 0,
})

export default function useRequirementGroups () {

  const requirementGroups = computed(() => requirementGroupsStore.value.data)
  const requirementGroupsAsArray = computed(() => Object.values(requirementGroupsStore.value.data))
  const requirementGroupsTotalCount = computed(() => requirementGroupsStore.value.totalCount)

  async function fetchRequirementGroups (params) {
    const response = await getRequirementGroups({
      school: store.getters.school,
      ...params,
    }) || {}
    requirementGroupsStore.value.data = response.data || {}
    requirementGroupsStore.value.totalCount = response.totalCount

    return response
  }

  return {
    fetchRequirementGroups,
    requirementGroups,
    requirementGroupsAsArray,
    requirementGroupsTotalCount,
  }
}
